if (!customElements.get('three-columns-slideshow')) {
  customElements.define(
    'three-columns-slideshow',
    class ThreeColumnsSlideshow extends HTMLElement {
      constructor() {
        super();
        this.selectedIndex = Number(this.dataset.selectedIndex || 0);
        this.autoplayDelay = Number(this.dataset.autoplay || 0);
        this.timer = null;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.three-columns-slideshow__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-three-columns-slideshow-dot]'));
        this.prevButton = this.querySelector('[data-three-columns-slideshow-prev]');
        this.nextButton = this.querySelector('[data-three-columns-slideshow-next]');

        this.prevButton?.addEventListener('click', this.previous);
        this.nextButton?.addEventListener('click', this.next);
        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
        this.addEventListener('mouseenter', this.stopAutoplay);
        this.addEventListener('mouseleave', this.startAutoplay);

        this.select(this.selectedIndex, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.prevButton?.removeEventListener('click', this.previous);
        this.nextButton?.removeEventListener('click', this.next);
        this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
        this.removeEventListener('mouseenter', this.stopAutoplay);
        this.removeEventListener('mouseleave', this.startAutoplay);
        this.stopAutoplay();
      }

      previous = () => {
        this.select(this.selectedIndex - 1);
      };

      next = () => {
        this.select(this.selectedIndex + 1);
      };

      onDotClick = (event) => {
        this.select(Number(event.currentTarget.dataset.threeColumnsSlideshowDot || 0));
      };

      select(index, restart = true) {
        if (!this.slides.length) return;

        const nextIndex = (index + this.slides.length) % this.slides.length;
        this.selectedIndex = nextIndex;
        this.dataset.selectedIndex = String(nextIndex);

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === nextIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === nextIndex);
        });

        if (restart) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      startAutoplay = () => {
        if (!this.autoplayDelay || this.slides.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.next(), this.autoplayDelay);
      };

      stopAutoplay = () => {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      };
    }
  );
}
